/**
 * Minimal SPA navigation: push the path and notify listeners (AuthedApp listens for popstate to
 * switch views) — avoids a full reload while keeping the URL shareable/refreshable.
 */
export function navigate(path: string): void {
  window.history.pushState({}, '', path);
  window.dispatchEvent(new PopStateEvent('popstate'));
}
